import './react-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './lib/sentry';
import App from './App.tsx';
import './index.css';

// Initialize Sentry before rendering the app
initSentry();

createRoot(document.getElementById('root')!).render(<App />);
